import { render, staticRenderFns } from "./FlexSpacer.vue?vue&type=template&id=637513d2&"
import script from "./FlexSpacer.vue?vue&type=script&lang=js&"
export * from "./FlexSpacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports